import PropTypes from 'prop-types';
import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import ScenarioSelectionRedefinedSectionMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ScenarioSelectionRedefinedSectionMetaOverride';
import { GoalStrategyOverviewSectionLayout } from './GoalStrategyOverviewSectionLayout';

export const GoalStrategyOverviewSection = ({ resource }) => {
  return (
    <MetaResourceRenderer
      resource={resource}
      layout={GoalStrategyOverviewSectionLayout}
      metaOverrideSet={ScenarioSelectionRedefinedSectionMetaOverride}
    />
  );
};

GoalStrategyOverviewSection.propTypes = {
  resource: PropTypes.object.isRequired,
};
